var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("a-tag", [_vm._v(_vm._s(_vm.$t("chatbotv2.tag")) + " 1")]),
      _vm._v(" "),
      _c("a-tag", [
        _c(
          "a",
          { attrs: { href: "https://github.com/vueComponent/ant-design" } },
          [_vm._v(_vm._s(_vm.$t("chatbotv2.link")))]
        ),
      ]),
      _vm._v(" "),
      _c("a-tag", { attrs: { closable: "" }, on: { close: _vm.log } }, [
        _vm._v(_vm._s(_vm.$t("chatbotv2.tag")) + " 2"),
      ]),
      _vm._v(" "),
      _c(
        "a-tag",
        {
          attrs: { closable: "" },
          on: {
            close: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("chatbotv2.preventDefault")))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }